import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';

import { acceptCookiePolicy } from '../../../application/actions';

const mapStateToProps = ({ application: { cookiePolicyState } }) => ({ cookiePolicyState });
const mapDispatchToProps = { acceptCookiePolicy };

@Radium
@connect(mapStateToProps, mapDispatchToProps)
export default class CookieNotification extends React.Component {
  static propTypes = {
    acceptCookiePolicy: PropTypes.func.isRequired,
    cookiePolicyState: PropTypes.string
  };

  static defaultProps = {
    cookiePolicyState: null
  };

  render() {
    const { acceptCookiePolicy, cookiePolicyState } = this.props;

    return (
      !cookiePolicyState &&
        <div style={styles.base}>
          Tento web používá k poskytování služeb a analýze návštěvnosti soubory cookie. Udělením souhlasu jste s tímto srozuměni.
          <Button bsStyle="primary" bsSize="xs" style={styles.button} onClick={acceptCookiePolicy}>Souhlasím</Button>
          <LinkContainer to="/zasady-cookies">
            <Button bsSize="xs">Nastavení</Button>
          </LinkContainer>
        </div>
    );
  }
}

const styles = {
  base: {
    position: 'fixed',
    bottom: 0,
    backgroundColor: '#5d9f51',
    color: '#FFF',
    width: '100%',
    textAlign: 'center',
    borderTop: '2px solid #E7E7E7'
  },
  button: {
    margin: 5
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/cookie_notification/index.jsx